import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URI,
});

/**
 * Extrai a mensagem que a API devolveu no corpo do erro.
 *
 * O Lumen responde de duas formas: `message` como texto, quando é uma regra de
 * negócio ("Já existe uma distribuidora com esse nome."), e `message` como o
 * objeto de erros do validador, no formato {campo: ["mensagem"]}.
 */
const extractApiMessage = error => {
  const message = error?.response?.data?.message;

  if (!message) {
    return null;
  }

  if (typeof message === 'string') {
    return message;
  }

  if (Array.isArray(message)) {
    return message.filter(Boolean).join(' ') || null;
  }

  if (typeof message === 'object') {
    const texts = Object.values(message).flat();

    return texts.filter(Boolean).join(' ') || null;
  }

  return null;
};

/**
 * Faz a mensagem da API chegar à tela.
 *
 * A maior parte do sistema exibe o erro com `toast.error(`${err}`)`, o que
 * mostrava textos como "AxiosError: Request failed with status code 400" —
 * sem utilidade nenhuma para quem está usando. Reescrevendo `message` aqui, no
 * único ponto por onde todas as requisições passam, o motivo real do erro
 * aparece em toda a aplicação sem precisar mexer em cada chamada.
 *
 * `name` fica em branco de propósito: o toString() de um Error com nome vazio
 * devolve só a mensagem, sem o prefixo "AxiosError:".
 *
 * `error.response` continua intacto, então quem já lê `err.response.data`
 * segue funcionando igual.
 */
api.interceptors.response.use(
  response => response,
  error => {
    // Troca de senha obrigatória (primeiro acesso, ou credenciais reenviadas
    // com a sessão aberta): a API só aceita trocar a senha. Marca o usuário
    // guardado e leva para a tela Alterar senha (ProtectedRoute mantém lá).
    if (error.response?.data?.password_change_required) {
      try {
        const saved = JSON.parse(localStorage.getItem('authenticatedUser'));
        if (saved && !saved.must_change_password) {
          localStorage.setItem(
            'authenticatedUser',
            JSON.stringify({ ...saved, must_change_password: true }),
          );
        }
      } catch (e) {
        // sem o usuário guardado, a guarda de rotas manda para o login
      }

      if (window.location.pathname !== '/alterar-senha') {
        window.location.assign('/alterar-senha');
      }
    }

    const apiMessage = extractApiMessage(error);

    if (apiMessage) {
      error.message = apiMessage;
      error.name = '';
    }

    return Promise.reject(error);
  },
);

export default api;
